// Which product fields the upload page shows for a category, beyond the ones
// the server says are required (those always show, and are enforced).
//
// A category Daniel has saved choices for on his required-fields page
// (https://claude.ai/artifact/J1esfSF4qH4dhEnVk6LtvK, db doc
// `config/required-fields`) is in SAVED_OPTIONAL: it shows the required fields
// plus its optional ones, and nothing else -- his "Not used" fields stay hidden
// even when they hold a value. Adding a category is one line there, once its
// required ones are in the server's photoPipeline/productRequirements.js.
//
// Every other category keeps the starting point: the fields in
// OPTIONAL_BY_CATEGORY, plus any field that already holds a value, so nothing
// on the product is hidden.

// Every field the server returns, in the order the panel lays them out.
export const FIELD_ORDER = [
    'weight', 'ring_size', 'width', 'height', 'length',
    'name', 'metal', 'color', 'gemstones', 'center_stone', 'side_stones', 'side_stone_count', 'band_width', 'watch_model',
]

const EVERYWHERE = ['weight', 'name', 'metal', 'color', 'gemstones']
const RING = ['center_stone', 'side_stones', 'band_width']
const LENGTH = ['length']
const WATCH = ['watch_model']

// Saved choices: category -> its "Optional" fields.
const SAVED_OPTIONAL = {
    'Rings': ['name', 'gemstones', 'center_stone', 'side_stones', 'side_stone_count', 'band_width'],
    // Required (server): weight, metal, color, length (Daniel, 2026-11-04).
    'Bracelets': ['name', 'gemstones'],
}

// The categories CreateProduct gives a length (categoryNeedsLength).
const OPTIONAL_BY_CATEGORY = {
    'Rings': RING,
    "Men's Rings": RING,
    'Engagement Rings': RING,
    'Baby Rings': RING,
    'Wedding Bands': RING,
    'Chains': LENGTH,
    'Necklaces': LENGTH,
    'Choker': LENGTH,
    'Charm Necklace Set': LENGTH,
    'Bracelets': LENGTH,
    "Men's Bracelets": LENGTH,
    'Baby Bracelets': LENGTH,
    'Anklets': LENGTH,
    "Men's Watches": WATCH,
    "Women's Watches": WATCH,
}

function hasValue(field) {
    const value = field?.value
    if (value === null || value === undefined || value === '') return false
    return !Array.isArray(value) || value.length > 0
}

export function shownFieldKeys(category, required = [], fields = {}) {
    if (Object.hasOwn(SAVED_OPTIONAL, category)) {
        const shown = new Set([...required, ...SAVED_OPTIONAL[category]])
        return FIELD_ORDER.filter(key => shown.has(key))
    }
    const shown = new Set([
        ...required,
        ...EVERYWHERE,
        ...(Object.hasOwn(OPTIONAL_BY_CATEGORY, category) ? OPTIONAL_BY_CATEGORY[category] : []),
        ...Object.keys(fields).filter(key => hasValue(fields[key])),
    ])
    return FIELD_ORDER.filter(key => shown.has(key))
}
